


















import { Vue, Component } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import GetAcceptLogo from '@/assets/icons/getacceptlogo.svg';

@Component({
  name: 'BaseMarketingModal',
  components: {
    Icon,
    GetAcceptLogo,
  },
})
export default class BaseMarketingModal extends Vue {}
